import React, { Component } from 'react';

class ProjectStyler extends Component {
  componentDidMount() {
    // Listen for project config
    window.appEvents.on('projectConfigReceived', this.applyProjectStyles);
  }

  componentWillUnmount() {
    window.appEvents.removeListener('projectConfigReceived', this.applyProjectStyles);
  }

  applyProjectStyles = (config) => {
    console.log('Applying project styles:', config);

    // Apply title
    if (config.title) {
      document.title = config.title;
      console.log('Applied page title:', config.title);
    }

    // Apply favicon
    if (config.favicon) {
      // Remove existing favicon if any
      let existingFavicon = document.querySelector('link[rel="icon"]');
      if (existingFavicon) {
        existingFavicon.remove();
      }

      // Create new favicon link
      const faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      faviconLink.type = 'image/x-icon';
      faviconLink.href = config.favicon;
      document.head.appendChild(faviconLink);

      console.log('Applied favicon:', config.favicon);
    }

    // Apply background
    if (config.background) {
      const body = document.body;
      if (config.background.type === 'color') {
        body.style.backgroundColor = config.background.value;
        body.style.backgroundImage = 'none';
      } else if (config.background.type === 'image') {
        body.style.backgroundImage = `url(${config.background.value})`;
        body.style.backgroundSize = 'cover';
        body.style.backgroundPosition = 'center';
        body.style.backgroundRepeat = 'no-repeat';
        body.style.backgroundAttachment = 'fixed';
      }
    }

    // Apply typography
    if (config.typography) {
      // Load custom font if URL provided
      if (config.typography.fontUrl) {
        // Check if font link already exists
        let existingLink = document.getElementById('project-font-link');
        if (existingLink) {
          existingLink.remove();
        }

        // Create link element to load the font
        const link = document.createElement('link');
        link.id = 'project-font-link';
        link.rel = 'stylesheet';
        link.href = config.typography.fontUrl;
        document.head.appendChild(link);

        console.log('Loading custom font from:', config.typography.fontUrl);
      }

      const root = document.getElementById('root');
      if (root) {
        if (config.typography.fontFamily) {
          root.style.fontFamily = config.typography.fontFamily;
        }
        if (config.typography.color) {
          root.style.color = config.typography.color;
        }
      }

      // Also apply to body as fallback
      if (config.typography.fontFamily) {
        document.body.style.fontFamily = config.typography.fontFamily;
      }

      // Apply custom font to .icon span elements
      if (config.typography.fontFamily) {
        // Check if icon span style element already exists
        let existingIconStyle = document.getElementById('project-icon-span-styles');
        if (existingIconStyle) {
          existingIconStyle.remove();
        }

        // Create style element for .icon span
        const iconSpanStyle = document.createElement('style');
        iconSpanStyle.id = 'project-icon-span-styles';
        iconSpanStyle.textContent = `.icon span { font-family: ${config.typography.fontFamily} !important; }`;
        document.head.appendChild(iconSpanStyle);

        console.log('Applied custom font to .icon span:', config.typography.fontFamily);
      }
    }

    // Apply logo as background of header
    if (config.logo) {
      const header = document.querySelector('.header');
      if (header) {
        header.style.backgroundImage = `url(${config.logo})`;
        header.style.backgroundSize = 'contain';
        header.style.backgroundPosition = 'center';
        header.style.backgroundRepeat = 'no-repeat';
      }
    }

    // Apply button styles
    console.log('button', config)
    if (config.button) {
      // Check if button style element already exists
      let existingButtonStyle = document.getElementById('project-button-styles');
      if (existingButtonStyle) {
        existingButtonStyle.remove();
      }

      // Build CSS for buttons and selects
      let buttonCss = '.btn, button.btn, .sources-choice select {';

      if (config.button.color) {
        buttonCss += `color: ${config.button.color} !important;`;
      }
      if (config.button.background) {
        buttonCss += `background: ${config.button.background} !important;`;
      }
      if (config.button.textTransform) {
        buttonCss += `text-transform: ${config.button.textTransform} !important;`;
      }
      if (config.button.border) {
        buttonCss += `border: ${config.button.border} !important;`;
      }
      if (config.button.borderRadius) {
        buttonCss += `border-radius: ${config.button.borderRadius} !important;`;
      }

      buttonCss += '}';

      // Create style element with button styles
      const buttonStyle = document.createElement('style');
      buttonStyle.id = 'project-button-styles';
      buttonStyle.textContent = buttonCss;
      document.head.appendChild(buttonStyle);

    }

    // Inject custom CSS
    if (config.customCss) {
      // Check if custom style element already exists
      let existingStyle = document.getElementById('project-custom-css');
      if (existingStyle) {
        existingStyle.remove();
      }

      // Create style element with custom CSS
      const style = document.createElement('style');
      style.id = 'project-custom-css';
      style.textContent = config.customCss;
      document.head.appendChild(style);

      console.log('Injected custom CSS for project');
    }

    // Store config in state or context if needed for other components
    if (this.props.onConfigLoaded) {
      this.props.onConfigLoaded(config);
    }
  }

  render() {
    return null; // This component doesn't render anything
  }
}

export default ProjectStyler;
